import React, {useEffect, useState} from 'react'
import {Link, useLocation, useNavigate} from 'react-router-dom'
import {KTCard, KTCardBody, KTSVG} from '../../../../../_metronic/helpers'
import {TriggersListWrapper} from '../../triggers/triggers-list/TriggersList'
import {ScrappingListHeader} from '../scrapping-table/components/header/ScrappingListHeader'
import {ScrappingTable} from '../scrapping-table/table/ScrappingTable'
import {Line, Circle} from 'rc-progress'
import { writeTextFile } from '../scrapping-table/core/_requests'
import { useCompanies } from '../../../auth/core/Companies'

interface OutPutViewProps {
  data: string;
  clearData: (value: string) => void
  websiteUrl: string
}
const OutPutView: React.FC<OutPutViewProps> = ({data, clearData,websiteUrl}) => {
  const [outputData, setOutputData]:any = useState(data)
  const [generatingFile, setgeneratingFile] = useState(false);
  const {defaultCompany} = useCompanies()
  const navigate = useNavigate()
  const location = useLocation();

  const handleClear = () => {
   setOutputData('')
    clearData('')
  }

  useEffect(() => {
    if (location.state) {
      setOutputData(location.state);
    }
  }, [location.state]);

  const redirectToRoute = () => {
    navigate(-1)
  } // Replace with the actual route you want to redirect to  };

  const generateFile = async () => {
    let data = {
      text: outputData,
      fileName: "File-Merging.txt",
      company_name: defaultCompany?.company_id,
    }
    setgeneratingFile(true)
    await writeTextFile(data);
    setgeneratingFile(false)
    redirectToRoute();
  }

  return (
    <>
      <div className='d-flex flex-column flex-center text-center mt-5'>
        <div className='card card-flush w-lg-950px p-10'>
          <textarea
            className='form-control'
            rows={15}
            id='comment'
            value={outputData}
            onChange={(e) => setOutputData(e.target.value)}
          ></textarea>
        </div>
        <div className='mt-5 mb-20'>
          <button type='button' className='btn btn-md btn-primary me-5' onClick={handleClear}>
            Clear
          </button>
          <button className='btn btn-md btn-primary' onClick={generateFile} disabled={generatingFile}>
            {generatingFile ? (
              <div className='spinner-border spinner-border-sm' role='status'>
                <span className='visually-hidden'>Please Wait...</span>
              </div>
            ) : (
              'Generate File'
            )}
          </button>
        </div>
      </div>
    </>
  )
}

export {OutPutView}
